class AccessManager {
    
    static permissions = [];

    static get enabled () {
        return AccessManager.permissions?.length > 0;
    }

    static setPermissions(permissions) {
        AccessManager.permissions = permissions;
    }

    static hasGroup (group = '') {
        if (AccessManager.enabled === true) {
            return AccessManager.permissions.some((key) => key.startsWith(group));
        }

        return true;
    }

    static hasPermissions (permissions = []) {
        if (AccessManager.enabled === true) {
            return permissions.every((permission) => AccessManager.permissions.includes(permission));
        }

        return true;
    }

    static hasSomePermissions(permissions = []) {
        if (AccessManager.enabled === true) {
            return permissions.some((permission) => AccessManager.permissions.includes(permission));
        }

        return true;
    }
}

export { AccessManager }